import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

// Feature imports - screaming architecture
import OrderForm from "@/features/order-journey/pages/OrderForm";
import PaymentSelection from "@/features/order-journey/pages/PaymentSelection";
import OrderConfirmation from "@/features/order-journey/pages/OrderConfirmation";
import LegalPage from "@/features/order-journey/pages/LegalPage";
import CustomerOrders from "@/features/customer/pages/CustomerOrders";
import AdminDashboard from "@/features/admin/pages/AdminDashboard";
import OrgaConfigurationPage from "@/features/admin/pages/OrgaConfigurationPage";
import BalanceHistoryPage from "@/features/admin/pages/BalanceHistoryPage";
import SavPage from "@/features/admin/pages/SavPage";
import AnalyticsDashboardPage from "@/features/admin/pages/AnalyticsDashboardPage";
import CustomersPage from "@/features/admin/pages/CustomersPage";
import ShippingCreditsPage from "@/features/admin/pages/ShippingCreditsPage";
import ShippingMethodsSearch from "@/features/admin/components/ShippingMethodsSearch";
import { LiveAssistant } from "@/features/admin/components/LiveAssistant/LiveAssistant";
import CreateOrganizationPage from "@/pages/CreateOrganizationPage";
import ManageOrganizationsPage from "@/pages/ManageOrganizationsPage";

import LandingPage from "@/pages/LandingPage";
import ProtectedRoute from "./ProtectedRoute";
import OrganizationGuard from "./OrganizationGuard";
import OrderLayout from "@/layouts/OrderLayout";

/**
 * Application routes organized by business domains with organizationId parameter
 */
export const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Redirection automatique vers /order quand on visite /orga/:idorga */}
      <Route path="/orga/:idorga" element={<Navigate to="order" replace />} />
      {/* Order Journey - Protected by OrganizationGuard (vérifie isActive + Stripe validé) */}
      <Route
        path="/orga/:idorga/order"
        element={
          <OrganizationGuard>
            <OrderLayout>
              <OrderForm />
            </OrderLayout>
          </OrganizationGuard>
        }
      />

      <Route
        path="/orga/:idorga/order/payment"
        element={
          <OrganizationGuard>
            <OrderLayout>
              <PaymentSelection />
            </OrderLayout>
          </OrganizationGuard>
        }
      />
      <Route
        path="/orga/:idorga/order/confirmation"
        element={
          <OrganizationGuard>
            <OrderLayout>
              <OrderConfirmation />
            </OrderLayout>
          </OrganizationGuard>
        }
      />

      {/* Legal pages - Public access */}
      <Route
        path="/orga/:idorga/legal"
        element={
          <OrderLayout>
            <LegalPage />
          </OrderLayout>
        }
      />

      {/* Customer Management - Pas de protection OrganizationGuard pour permettre l'accès aux commandes */}
      <Route
        path="/orga/:idorga/mes-commandes"
        element={
          <ProtectedRoute>
            <CustomerOrders />
          </ProtectedRoute>
        }
      />

      {/* Administration - Routes protégées */}
      <Route
        path="/orga/:idorga/admin"
        element={
          <ProtectedRoute requireAdmin requireAccess>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/orga/:idorga/admin/configuration"
        element={
          <ProtectedRoute requireAdmin requireAccess>
            <OrgaConfigurationPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/orga/:idorga/shipping-methods/search"
        element={
          <ProtectedRoute requireAdmin requireAccess>
            <ShippingMethodsSearch />
          </ProtectedRoute>
        }
      />
      <Route
        path="/orga/:idorga/admin/live-assistant"
        element={
          <ProtectedRoute requireAdmin requireAccess>
            <LiveAssistant />
          </ProtectedRoute>
        }
      />
      <Route
        path="/orga/:idorga/admin/sav"
        element={
          <ProtectedRoute requireAdmin requireAccess>
            <SavPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/orga/:idorga/admin/balance"
        element={
          <ProtectedRoute requireAdmin requireAccess>
            <BalanceHistoryPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/orga/:idorga/admin/analytics"
        element={
          <ProtectedRoute requireAdmin requireAccess>
            <AnalyticsDashboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/orga/:idorga/admin/customers"
        element={
          <ProtectedRoute requireAdmin requireAccess>
            <CustomersPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/orga/:idorga/admin/shipping-credits"
        element={
          <ProtectedRoute requireAdmin requireAccess>
            <ShippingCreditsPage />
          </ProtectedRoute>
        }
      />

      {/* Organization Management */}
      <Route
        path="/organizations/create"
        element={
          <ProtectedRoute>
            <CreateOrganizationPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/organizations/manage"
        element={<ManageOrganizationsPage />}
      />

      {/* Espace Client - Mes commandes (toutes organisations) */}
      <Route
        path="/my-orders"
        element={
          <ProtectedRoute>
            <CustomerOrders />
          </ProtectedRoute>
        }
      />


      {/* Auth pages */}
      <Route path="/auth/login" element={<LandingPage />} />
      <Route path="/auth/register" element={<LandingPage />} />

      {/* Landing page */}
      <Route path="/" element={<LandingPage />} />
    </Routes>
  );
};
